import { render, staticRenderFns } from "./TicketError.vue?vue&type=template&id=ff95db1a&scoped=true&"
import script from "./TicketError.vue?vue&type=script&lang=js&"
export * from "./TicketError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff95db1a",
  null
  
)

export default component.exports